import { findConnectionByType } from "../utils/findConnectionByType";
import { QConnection } from "./QConnection";
import { isInternetExplorer } from "../utils/isInternetExplorer";

export class QTile {
  constructor() {
    this.fConnections = null;
    this.top = 0;
    this.bottom = 0;
    this.left = 0;
    this.right = 0;
    this.fScore = Number.POSITIVE_INFINITY;
    this.fFlag = "";
    this.fBestNeighbor = null;
    this.fBestNeighborType = "";
    this.fCenter = { x: 0, y: 0 };
    this.fID = -1;
    this.fParentArray = null;
    this.fBrowserIsInternetExplorer = false;
  }

  InitTile(box) {
    this.top = box.top;
    this.bottom = box.bottom;
    this.left = box.left;
    this.right = box.right;
    this.fConnections = [];
    this.fCenter = {
      x: Math.round((this.left + this.right) / 2),
      y: Math.round((this.top + this.bottom) / 2)
    };

    this.fBrowserIsInternetExplorer = isInternetExplorer();
  }

  UpdateBox(box) {
    this.top = box.top;
    this.bottom = box.bottom;
    this.left = box.left;
    this.right = box.right;
    this.fCenter = {
      x: Math.round((this.left + this.right) / 2),
      y: Math.round((this.top + this.bottom) / 2)
    };
  }

  SetParentArray(parentArray) {
    this.fParentArray = parentArray;
  }

  SetID(id) {
    this.fID = id;
  }

  GetCenter() {
    return this.fCenter;
  }

  /**
   * @return {number}
   */
  StandardDistance(otherTile) {
    var otherCenter = otherTile.GetCenter();
    var distance = Math.sqrt(
      (this.fCenter.x - otherCenter.x) * (this.fCenter.x - otherCenter.x) +
        (this.fCenter.y - otherCenter.y) * (this.fCenter.y - otherCenter.y)
    );

    return distance;
  }

  UpdateConnection(connection) {
    if (this.fBrowserIsInternetExplorer) {
      for (var i = 0; i < this.fConnections.length; i++) {
        if (this.fConnections.fType === connection.fType) {
          this.fConnections.splice(i, 1, connection);
          return;
        }
      }

      // if we are here, connection didn't exists, so cerate one
      this.fConnections.push(connection);
    } else {
      var foundIndex = this.fConnections.findIndex(findConnectionByType, connection);
      if (foundIndex === -1) {
        this.fConnections.push(connection);
      } else {
        this.fConnections.splice(foundIndex, 1, connection);
      }
    }
  }

  RemoveConnection(direction) {
    if (this.fBrowserIsInternetExplorer) {
      for (var i = 0; i < this.fConnections.length; i++) {
        if (this.fConnections.fType === direction) {
          this.fConnections.splice(i, 1);
          return;
        }
      }
    } else {
      var connection = new QConnection();
      connection.InitConnection(null, null, 0, direction);
      var foundIndex = this.fConnections.findIndex(findConnectionByType, connection);
      if (foundIndex !== -1) {
        this.fConnections.splice(foundIndex, 1);
      }
    }
  }

  /**
   * @return {string}
   */
  RelationType(otherTile) {
    var relationType = "unknown";
    var otherCenter = otherTile.GetCenter();
    if (otherCenter.x === this.fCenter.x) {
      if (otherCenter.y < this.fCenter.y) {
        relationType = "up";
      } else {
        relationType = "down";
      }
    } else if (otherCenter.y === this.fCenter.y) {
      if (otherCenter.x < this.fCenter.x) {
        relationType = "left";
      } else {
        relationType = "right";
      }
    }

    return relationType;
  }

  Connect(otherTile) {
    var connection1 = new QConnection();
    var distance = this.StandardDistance(otherTile);
    var type1 = this.RelationType(otherTile);
    connection1.InitConnection(this, otherTile, distance, type1);
    this.UpdateConnection(connection1);

    var connection2 = new QConnection();
    var type2 = otherTile.RelationType(this);
    connection2.InitConnection(otherTile, this, distance, type2);
    otherTile.UpdateConnection(connection2);
  }

  InsertTileBetween(pt, tile1, tile2) {
    var t12Direction = "";
    var t21Direction = "";
    if (tile1.fCenter.y === tile2.fCenter.y) {
      if (tile1.fCenter.x < tile2.fCenter.x) {
        t12Direction = "right";
        t21Direction = "left";
      } else {
        t12Direction = "left";
        t21Direction = "right";
      }
    } else if (tile1.fCenter.y < tile2.fCenter.y) {
      t12Direction = "down";
      t21Direction = "up";
    } else {
      t12Direction = "up";
      t21Direction = "down";
    }

    tile1.RemoveConnection(t12Direction);
    tile2.RemoveConnection(t21Direction);

    var newTile = new QTile();
    var box = {
      left: pt.x - 2,
      right: pt.x + 2,
      top: pt.y - 2,
      bottom: pt.y + 2
    };
    newTile.InitTile(box);
    newTile.SetParentArray = tile1.fParentArray;

    tile1.Connect(newTile);
    tile2.Connect(newTile);

    newTile.fParentArray.AddTile(newTile);
    return newTile;
  }

  SplitVertical(y, direction) {
    if (y <= this.top || y >= this.bottom) {
      return { topTile: null, bottomTile: null };
    }

    if (typeof direction === "undefined") {
      direction = "";
    }

    // - I need to split myself and become the top one.
    // - Create a bottom one
    // - update my connections
    // - call split vertical for my left fone

    var bottomNeighbor = this.GetNeighbor("down");

    var splitBottomTile = new QTile();
    var box = {
      left: this.left,
      right: this.right,
      top: y,
      bottom: this.bottom
    };

    splitBottomTile.InitTile(box);
    this.fParentArray.AddTile(splitBottomTile);

    box = {
      left: this.left,
      right: this.right,
      top: this.top,
      bottom: y
    };

    this.UpdateBox(box);

    this.Connect(splitBottomTile);
    if (bottomNeighbor) {
      splitBottomTile.Connect(bottomNeighbor);
    }

    var tileLeft = null;
    var tileRight = null;
    switch (direction) {
      case "left":
        tileLeft = this.GetNeighbor("left");
        break;

      case "right":
        tileRight = this.GetNeighbor("right");
        break;

      case "":
        tileLeft = this.GetNeighbor("left");
        tileRight = this.GetNeighbor("right");
        break;

      default:
        break;
    }

    var newTilesLeft = null;
    var newTilesRight = null;

    if (tileLeft) {
      newTilesLeft = tileLeft.SplitVertical(y, "left");
    }

    if (tileRight) {
      newTilesRight = tileRight.SplitVertical(y, "right");
    }

    if (newTilesLeft && newTilesLeft.topTile) {
      this.Connect(newTilesLeft.topTile);
    }

    if (newTilesLeft && newTilesLeft.bottomTile) {
      splitBottomTile.Connect(newTilesLeft.bottomTile);
    }

    if (newTilesRight && newTilesRight.topTile) {
      this.Connect(newTilesRight.topTile);
    }

    if (newTilesRight && newTilesRight.bottomTile) {
      splitBottomTile.Connect(newTilesRight.bottomTile);
    }

    var returnPair = {
      topTile: this,
      bottomTile: splitBottomTile
    };

    return returnPair;
  }

  SplitHorizontal(x, direction) {
    if (x <= this.left || x >= this.right) {
      return { leftTile: null, rightTile: null };
    }

    if (typeof direction === "undefined") {
      direction = "";
    }

    // - I need to split myself and become the left one.
    // - Create a right spilt tile
    // - update my connections
    // - call split horizontal for my top and bottom

    var rightNeighbor = this.GetNeighbor("right");

    var splitRightTile = new QTile();
    var box = {
      left: x,
      right: this.right,
      top: this.top,
      bottom: this.bottom
    };

    splitRightTile.InitTile(box);
    this.fParentArray.AddTile(splitRightTile);

    box = {
      left: this.left,
      right: x,
      top: this.top,
      bottom: this.bottom
    };

    this.UpdateBox(box);
    this.Connect(splitRightTile);

    if (rightNeighbor) {
      splitRightTile.Connect(rightNeighbor);
    }

    var tileTop = null;
    var tileBottom = null;
    switch (direction) {
      case "up":
        tileTop = this.GetNeighbor("up");
        break;

      case "down":
        tileBottom = this.GetNeighbor("down");
        break;

      case "":
        tileTop = this.GetNeighbor("up");
        tileBottom = this.GetNeighbor("down");
        break;

      default:
        break;
    }

    var newTilesTop = null;
    var newTilesBottom = null;

    if (tileTop) {
      newTilesTop = tileTop.SplitHorizontal(x, "up");
    }

    if (tileBottom) {
      newTilesBottom = tileBottom.SplitHorizontal(x, "down");
    }

    if (newTilesTop && newTilesTop.leftTile) {
      this.Connect(newTilesTop.leftTile);
    }

    if (newTilesTop && newTilesTop.rightTile) {
      splitRightTile.Connect(newTilesTop.rightTile);
    }

    if (newTilesBottom && newTilesBottom.leftTile) {
      this.Connect(newTilesBottom.leftTile);
    }

    if (newTilesBottom && newTilesBottom.rightTile) {
      splitRightTile.Connect(newTilesBottom.rightTile);
    }

    var returnPair = {
      leftTile: this,
      rightTile: splitRightTile
    };

    return returnPair;
  }

  GetNeighbor(direction) {
    var neighbor = null;
    for (var i = 0; i < this.fConnections.length; i++) {
      var connection = this.fConnections[i];
      if (connection.fType === direction) {
        neighbor = connection.fTargetTile;
        break;
      }
    }

    return neighbor;
  }

  LogTile(tile) {
    var msg = "Tile (" + tile.fID + ") ";
    msg += "[" + tile.left + ", " + tile.right + ", " + tile.top + ", " + tile.bottom + "] ";

    if (tile.fConnections) {
      for (var i = 0; i < tile.fConnections.length; i++) {
        msg += "( " + tile.fConnections[i].fType + ": ";
        msg += tile.fConnections[i].fTargetTile.fID;
        msg += ")";
      }
    }

    if (!tile.IsTileOK()) {
      msg += "  NOT OK";
    }

    console.log(msg);
  }

  IsTileOK() {
    var isOK = true;
    if (this.fConnections) {
      var leftTile = this.GetNeighbor("left");
      if (
        leftTile &&
        (this.top !== leftTile.top ||
          this.bottom !== leftTile.bottom ||
          this.left !== leftTile.right)
      ) {
        isOK = false;
      }

      var rightTile = this.GetNeighbor("right");
      if (
        rightTile &&
        (this.top !== rightTile.top ||
          this.bottom !== rightTile.bottom ||
          this.right !== rightTile.left)
      ) {
        isOK = false;
      }

      var topTile = this.GetNeighbor("up");
      if (
        topTile &&
        (this.left !== topTile.left || this.right !== topTile.right || this.top !== topTile.bottom)
      ) {
        isOK = false;
      }

      var bottomTile = this.GetNeighbor("down");
      if (
        bottomTile &&
        (this.left !== bottomTile.left ||
          this.right !== bottomTile.right ||
          this.bottom !== bottomTile.top)
      ) {
        isOK = false;
      }
    }

    return isOK;
  }

  HasEightNeighbors() {
    var numEightNeighbors = 0;
    var neighbor = this.GetNeighbor("left");
    if (neighbor) {
      numEightNeighbors++;
      var neighbor2 = neighbor.GetNeighbor("up");
      numEightNeighbors += neighbor2 !== null;
      neighbor2 = neighbor.GetNeighbor("down");
      numEightNeighbors += neighbor2 !== null;
    }

    neighbor = this.GetNeighbor("right");
    if (neighbor) {
      numEightNeighbors++;
      neighbor2 = neighbor.GetNeighbor("up");
      numEightNeighbors += neighbor2 !== null;
      neighbor2 = neighbor.GetNeighbor("down");
      numEightNeighbors += neighbor2 !== null;
    }

    neighbor = this.GetNeighbor("up");
    if (neighbor) {
      numEightNeighbors++;
      neighbor2 = neighbor.GetNeighbor("left");
      numEightNeighbors += neighbor2 !== null;
      neighbor2 = neighbor.GetNeighbor("right");
      numEightNeighbors += neighbor2 !== null;
    }

    neighbor = this.GetNeighbor("down");
    if (neighbor) {
      numEightNeighbors++;
      neighbor2 = neighbor.GetNeighbor("left");
      numEightNeighbors += neighbor2 !== null;
      neighbor2 = neighbor.GetNeighbor("right");
      numEightNeighbors += neighbor2 !== null;
    }

    return numEightNeighbors === 8;
  }
}
